module.exports = __webpack_public_path__ + "static/stereosun_full-f35e6d0ba3637e568094fa55571f9dbc.mp4";